import { useSelector } from "react-redux";

export default function UserAccess(value) {
  const { user } = useSelector((state) => state.auth);
  const index = user && user?.userRole?.includes(value);
  return index;
}
export function findUserAccess(value, arr = []) {
  const index = arr.length > 0 && arr?.includes(value);
  return index;
}
